import React from "react";
import GeneralSection from "./GeneralSection";
import { Route, Switch, Link } from "react-router-dom";

const SettingsTabs = () => {
  return (
    <>
      <div className="py-8">
        <div className="border-gray-200 border-b-2 pb-5">
          <div className="flex space-x-10 font-medium text-gray-700">
            <Link to="/settings/general">
              <h2 className="hover:text-indigo-600 cursor-pointer">General</h2>
            </Link>
            <Link to="/settings/password">
              <h2 className="hover:text-indigo-600 cursor-pointer">Password</h2>
            </Link>
            <Link to="/settings/plan">
              <h2 className="hover:text-indigo-600 cursor-pointer">Plan</h2>
            </Link>
            <Link to="/settings/billing">
              <h2 className="hover:text-indigo-600 cursor-pointer">Billing</h2>
            </Link>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path="/settings/general"
            render={() => (
              <>
                <GeneralSection label="general" />
              </>
            )}
          />

          <Route
            exact
            path="/settings/password"
            render={() => (
              <>
                <GeneralSection label="password" />
              </>
            )}
          />
        </Switch>
      </div>
    </>
  );
};

export default SettingsTabs;
